import styled, { keyframes } from "styled-components";
import { fontMixins } from "../../../../../styles";
import { motion } from "framer-motion";

const loaderRotate = keyframes`

  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }

`;

export const ButtonBuy_Container = styled(motion.button)`
	display: flex;

	align-items: center;
	justify-content: center;
	align-self: flex-start;
	margin-top: auto;
	line-height: 25px;
	${fontMixins(10, 500)};
	color: #fff;
	background: #d89f5b;
	border-radius: 4px;
	border: 0;
	width: 150px;
	min-height: 25px;
	text-transform: uppercase;
	cursor: pointer;
	transition: background 0.2s, opacity 0.2s;

	&:hover:not(:disabled) {
		background: #c98e4d;
	}

	&:disabled {
		cursor: default;
		opacity: 0.85;
	}
`;

export const ButtonBuy_Content = styled(motion.span)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
`;

export const ButtonBuy_Loader = styled.span`
	display: inline-flex;
	width: 14px;
	height: 14px;
	border-radius: 50%;
	border: 2px solid rgba(255, 255, 255, 0.35);
	border-top-color: #fff;
	animation: ${loaderRotate} 0.7s linear infinite;
`;
